export const version = '2.38.3';
//# sourceMappingURL=version.js.map